import { Card, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  YAxis,
} from "recharts";

const ChartComponent = ({ title, data, dataKeygrid, grid }) => {
  return (
    <Box
      sx={{
        mt: 10,
      }}
    >
      <>
        <Typography variant="h5" component={"h2"}>
          Total Sales Ksh :{" "}
          {
            //get total amounts from orders
            data && data.reduce((total, order) => total + order.totalPrice, 0)
          }
        </Typography>
        <Typography variant="h5" component="h2">
          {" "}
          {title}{" "}
        </Typography>
        <ResponsiveContainer
          height={"30vh"}
          width="100%"
          aspect={grid ? "1.5" : "1"}
        >
          <LineChart data={data}>
            <XAxis dataKey="" stroke="#5550bd" />
            <YAxis />
            <Legend />
            <Line type="monotone" dataKey="totalPrice" stroke="#5550bd" />
            <Tooltip />
            {grid && (
              <CartesianGrid stroke="#e0dfdf" strokeDashArray={1} />
            )}{" "}
          </LineChart>
        </ResponsiveContainer>
      </>
    </Box>
  );
};

export default ChartComponent;
